<template>
  <header class="masthead text-white text-center">
    <div class="container">
      <section class="renewal-notice" aria-label="リズム電卓への移行案内">
        <p>
          Rhythm Reader (リズムリーダー)は、リズム電卓としてリニューアルしました。
          <a href="https://rhythm-calculator.colour-field.jp/ja">くわしく</a>
        </p>
      </section>
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <h1 class="py-4"><span>電卓のように</span><span>リズムを</span><span>入力、</span><span>再生</span></h1>
          <p>リズムを読むためのメトロノームアプリ</p>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'top'
}
</script>

<style scoped>
header.masthead {
  position: relative;
  background: linear-gradient(
    var(--theme-color) 0%,
   /* rgba(35, 59, 103, 1) 0%, */
    rgba(50, 59, 103, 0.55) 5%,
    rgba(45, 59, 103, 0.55) 75%,
    rgba(40, 59, 103, 0.55) 90%,
    /* rgba(255,255,255, 1) 100%), */
    #f8f9fa 100%),
    url("/img/header3.jpg") no-repeat center center;
  background-size: cover;
  text-shadow: 0 0 10px #000;
  padding-top: 5rem;
  padding-bottom: 8rem;
}

header.masthead h1 {
  font-size: 2rem;
}

@media (min-width: 768px) {
  header.masthead {
    padding-top: 10rem;
    padding-bottom: 12rem;
  }
  header.masthead h1 {
    font-size: 3rem;
  }
}

header.masthead h1 span{
  display: inline-block;
}

.renewal-notice{
  margin: 0 auto 2rem;
  font-family: 'Sawarabi Gothic', sans-serif;
  text-shadow: none;
}

.renewal-notice p{
  max-width: 960px;
  margin: 0 auto;
  padding: 0.65rem 1rem;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
}

.renewal-notice a{
  display: inline-block;
  color: #ffffff;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 700;
}
</style>
